export class SignLocationType {
  label: string;
  value: number;

  constructor(label: string, value: number) {
    this.label = label;
    this.value = value;
  }
}

export const SignLocationTypesChoices = {
  PHYSICAL: new SignLocationType('Fysieke locatie', 0),
  IN_PRODUCTION: new SignLocationType('In productie', 1),
  PLACED: new SignLocationType('Geplaatst', 2),
  TO_DISASSEMBLE: new SignLocationType('Nog af te breken intern', 3),
  DEFERRED: new SignLocationType('Uitgesteld', 4),
  PENDING_ORDER: new SignLocationType('Lopende bestelling', 5),
  FRAME_CORNER: new SignLocationType('Op kader', 6),
  IN_OFFER: new SignLocationType('In offerte', 7),
  PLACEMENT_IN_PROGRESS: new SignLocationType('Plaatsing bezig', 8),
  DIRECT_ORDER: new SignLocationType('Directe bestelling', 9),
};

export const SignLocationTypesChoiceArray = Object.values(
  SignLocationTypesChoices
);
